<script setup lang="ts">
import SeminarDetailAttention from './SeminarDetailAttention.vue';
import SeminarDetailSummary from './SeminarDetailSummary.vue';
import { type FragmentType, graphql } from '~/gql';

const props = defineProps<{ seminar: FragmentType<typeof Seminar> }>();

const Seminar = graphql(`
  fragment SeminarDetailSummarySectionSeminar on Seminar {
    id
    attention
    ...SeminarDetailTemplateSeminarDetailSummarySeminar
  }
`);

const seminar = useComputedFragment(Seminar, () => props.seminar);
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.container__hline" />
    <SeminarDetailSummary :seminar="seminar" />
    <template v-if="seminar.attention">
      <div :class="$style.container__hline" />
      <SeminarDetailAttention :attention="seminar.attention" />
    </template>
  </div>
</template>

<style module lang="scss">
.container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  &__hline {
    height: 1px;
    width: 100%;
    background-color: $color-border-low-emphasis;
  }
}
</style>
